module.exports = __webpack_public_path__ + "img/v1_no4_p4.e9886f8e.jpg";